import { Component, ReactNode } from 'react'

interface ErrorViewProps {
  message?: ReactNode
}

export class ErrorView extends Component<ErrorViewProps, { error?: string }> {
  public state: { error?: string } = {}

  public componentDidCatch(error) {
    console.error(error)
    this.setState({
      error: (error && error.message) || String(error) || 'Error',
    })
  }

  public render() {
    return (
      (this.state.error && this.props.message) ||
      this.state.error ||
      this.props.children ||
      null
    )
  }
}
